<template>
  <div class="p-10">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-model="formData.userName" required :rules="[{ required: true, message: '请输入姓名' }]"
                   name="userName" maxlength="50" autosize label="姓名"
                   placeholder="请输入姓名" input-align="right"/>

        <van-field input-align="right" name="userSex" :value="formData.userSex" label="性别"
                   required :rules="[{ required: true, message: '请选择性别' }]" placeholder="请选择性别">
          <template #input>
            <form-view-item @click.native="userSex.show = true" :value="formData.userSex"
                            placeholder="请选择性别"
                            :options="{data:userSex.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="userSex.show" position="bottom">
              <van-nav-bar title="选择性别" left-text="取消" right-text="确定"
                           @click-left="userSex.show = false"
                           @click-right="popupSubmit('userSex',{value:'dictValue'})"/>
              <van-search v-model="userSex.filterText" @input="pickerSearch($event,userSex,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="userSex" value-key="dictLabel" :columns="userSex.filteredData"
                          @cancel="userSex.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-model="formData.userAge" type="number" name="userAge" maxlength="50" autosize label="年龄"
                   placeholder="请输入年龄" input-align="right"/>
        <van-field v-model="formData.userTelephone" type="number" name="userTelephone" maxlength="50" autosize
                   label="手机号" placeholder="请输入手机号" input-align="right"/>

        <van-field input-align="right" name="companyId" :value="formData.companyId" label="所属客户"
                   placeholder="请选择所属客户">
          <template #input>
            <form-view-item :isShowIcon="false" :value="formData.companyId" placeholder="请选择所属客户"
                            :options="{data:companyId.data,showFields:'companyName',valueKey:'id'}"/>
          </template>
        </van-field>


        <van-field v-model="formData.userDeptName" required :rules="[{ required: true, message: '请输入所属部门' }]"
                   name="userDeptName" maxlength="50" autosize
                   :label="formData.industryType == '0' ? '所属部门' : '所在学院'"
                   :placeholder="`请输入${formData.industryType == '0' ? '所属部门' : '所在学院'}`"
                   input-align="right"/>
        <van-field v-if="formData.industryType != '0'" v-model="formData.userXi" name="userXi" maxlength="50" autosize
                   label="所在系" placeholder="请输入所在系" input-align="right"/>
        <van-field v-model="formData.userPost" name="userPost" maxlength="50" autosize label="职务"
                   placeholder="请输入职务" input-align="right"/>


        <van-field input-align="right" name="roleNature" :value="formData.roleNature" label="角色性质"
                   placeholder="请选择角色性质">
          <template #input>
            <form-view-item @click.native="roleNature.show = true" :value="formData.roleNature"
                            placeholder="请选择角色性质"
                            :options="{data:roleNature.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="roleNature.show" position="bottom">
              <van-nav-bar title="选择角色性质" left-text="取消" right-text="确定"
                           @click-left="roleNature.show = false"
                           @click-right="popupSubmit('roleNature',{value:'dictValue'})"/>
              <van-search v-model="roleNature.filterText" @input="pickerSearch($event,roleNature,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="roleNature" value-key="dictLabel" :columns="roleNature.filteredData"
                          @cancel="roleNature.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-model="formData.firstContact" name="firstContact" label="初次接触客户时间"
                   placeholder="初次接触客户时间" input-align="right">
          <template #input>
            <view-item @click.native="firstContact.show = true" :value="formData.firstContact"
                       placeholder="请选择初次接触客户时间"/>
            <van-calendar v-model="firstContact.show" :min-date="firstContact.minDate" ref="firstContact"
                          :show-confirm="false"
                          title="选择初次接触客户时间" @confirm="firstContactConfirm"></van-calendar>
          </template>
        </van-field>


        <van-field v-model="formData.userWorkPlace" name="userWorkPlace" maxlength="50" autosize label="工作地点/房间号"
                   placeholder="请输入工作地点/房间号" input-align="right"/>

        <van-field v-model="formData.userLeader" name="userLeader" maxlength="50" autosize label="直属领导"
                   placeholder="请输入直属领导" input-align="right"/>

        <van-field v-model="formData.userMobile" type="number" name="userMobile" maxlength="50" autosize
                   label="固定电话" placeholder="请输入固定电话" input-align="right"/>
        <van-field v-model="formData.userEmail" name="userEmail" maxlength="50" autosize label="邮箱"
                   placeholder="请输入邮箱" input-align="right"/>


        <van-field input-align="right" name="userEmpnasis" :value="formData.userEmpnasis" label="是否重点维护"
                   required :rules="[{ required: true, message: '请选择是否重点维护' }]"
                   placeholder="请选择是否重点维护">
          <template #input>
            <form-view-item @click.native="userEmpnasis.show = true" :value="formData.userEmpnasis"
                            placeholder="请选择是否重点维护"
                            :options="{data:userEmpnasis.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="userEmpnasis.show" position="bottom">
              <van-nav-bar title="选择是否重点维护" left-text="取消" right-text="确定"
                           @click-left="userEmpnasis.show = false"
                           @click-right="popupSubmit('userEmpnasis',{value:'dictValue'})"/>
              <van-search v-model="userEmpnasis.filterText" @input="pickerSearch($event,userEmpnasis,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="userEmpnasis" value-key="dictLabel" :columns="userEmpnasis.filteredData"
                          @cancel="userEmpnasis.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field input-align="right" name="userMain" :value="formData.userMain" label="是否关键联系人"
                   placeholder="请选择是否关键联系人">
          <template #input>
            <form-view-item @click.native="userMain.show = true" :value="formData.userMain"
                            placeholder="请选择是否关键联系人"
                            :options="{data:userMain.data,showFields:'dictLabel',valueKey:'dictValue'}"/>
            <van-popup v-model="userMain.show" position="bottom">
              <van-nav-bar title="选择是否关键联系人" left-text="取消" right-text="确定"
                           @click-left="userMain.show = false"
                           @click-right="popupSubmit('userMain',{value:'dictValue'})"/>
              <van-search v-model="userMain.filterText" @input="pickerSearch($event,userMain,'dictLabel')"
                          clearable
                          shape="round"/>
              <van-picker ref="userMain" value-key="dictLabel" :columns="userMain.filteredData"
                          @cancel="userMain.show = false"/>
            </van-popup>
          </template>
        </van-field>

        <van-field v-model="formData.userFamilyAddress" name="userFamilyAddress" type="textarea" maxlength="200"
                   rows="3" autosize
                   label="家庭住址"
                   placeholder="请输入家庭住址" input-align="right"/>
        <van-field v-model="formData.userLike" name="userLike" maxlength="50" autosize label="爱好"
                   placeholder="请输入爱好" input-align="right"/>
        <van-field v-model="formData.userStrongPoint" name="userStrongPoint" maxlength="50" autosize label="特长"
                   placeholder="请输入特长" input-align="right"/>
        <van-field input-align="right" name="companyProvince" :value="formData.companyProvince"
                   label="所属部门"
                   placeholder="请选择所属部门">
          <template #input>
            <form-view-item :isShowIcon="false" :value="formData.deptId" placeholder="请选择所属部门"
                            :options="{data:jurisdictionDeptTree,showFields:'label',valueKey:'value',childrenKey:'children'}"/>
          </template>
        </van-field>
        <van-field v-model="formData.userBusiness" name="userBusiness" type="textarea" maxlength="200" rows="3"
                   autosize label="业务范围" show-word-limit placeholder="请输入业务范围" input-align="right"/>
        <van-field v-model="formData.remark" name="remark" type="textarea" maxlength="200" rows="3" autosize
                   label="备注" show-word-limit placeholder="请输入备注" input-align="right"/>
      </van-cell-group>
    </van-form>


    <div class="bottom-bar-placeholder">
      <div class="bottom-bar flex">
        <div class="btn-item flex-1 bg-FFDB43" @click="submit(0)">
          {{ '确定' }}
        </div>
        <div v-if="!customerId" class="btn-item flex-2 bg-FFDB43" @click="submit(1)">
          {{ '保存并录入下一条' }}
        </div>
        <div class="btn-item flex-1 bg-FF" @click="goBack">
          {{ '返回' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getDictDataByType} from "@/api/dict";
import formViewItem from "@/components/formViewItem/index.vue";
import mixin from '@/mixin/default-form'
import {addUser, selectCustomerCompanyListAll, getCompany, editUser, getInfo} from '@/api/crm/index'
import {jurisdictionDeptTree} from "@/api/dept";
import cache from "@/plugins/cache";
import moment from "moment/moment";

class PickerOptions {
  constructor() {
    this.data = [];
    this.show = false;
    this.filteredData = [];
    this.filterText = '';
  }
}

export default {
  mixins: [mixin],
  components: {formViewItem},
  data() {
    return {
      // 联系人ID
      customerId: '',
      userSex: new PickerOptions(),
      companyId: new PickerOptions(),
      roleNature: new PickerOptions(),
      userEmpnasis: new PickerOptions(),
      userMain: new PickerOptions(),
      // 用印日期
      firstContact: {
        show: false,
        minDate: new Date(2010, 0, 1),
      },
      // 部门树
      jurisdictionDeptTree: [],
      formData: {
        industryType: "",
        companyId: "",
        userSex: "",
        userName: "",
        // 年龄
        userAge: "",
        userTelephone: "",
        // 所属部门/所在学院
        userDeptName: "",
        // 所在系
        userXi: "",
        // 职务
        userPost: "",
        // 角色性质
        roleNature: "",
        // 初次接触客户时间
        firstContact: "",
        // 工作地点/房间号
        userWorkPlace: "",
        // 直属领导
        userLeader: "",
        // 固定电话
        userMobile: "",
        userEmail: "",
        // 是否重点维护
        userEmpnasis: "",
        // 是否关键联系人
        userMain: "",
        userFamilyAddress: "",
        userLike: "",
        // 业务范围
        userBusiness: "",
        remark: ""
      }
    }
  },
  created() {
    const {companyId, customerId} = this.$route.query;
    this.customerId = customerId
    if (customerId) { // 修改时
      this.getInfo()
    }
    getCompany(companyId).then(res => {
      this.formData.industryType = res.data.industryType
    })

    this.formData.deptId = JSON.parse(cache.session.get('userInfo'))?.deptId
    this.formData.companyId = companyId
    jurisdictionDeptTree().then(res => {
      this.jurisdictionDeptTree = res.data
    })
    getDictDataByType('sys_user_sex').then(res => {
      this.userSex.data = res.data
      this.userSex.filteredData = res.data
    })
    getDictDataByType('customer_role_nature').then(res => {
      this.roleNature.data = res.data
      this.roleNature.filteredData = res.data
    })
    getDictDataByType('customer_user_empnasis').then(res => {
      this.userEmpnasis.data = res.data
      this.userEmpnasis.filteredData = res.data
    })

    getDictDataByType('customer_user_main').then(res => {
      this.userMain.data = res.data
      this.userMain.filteredData = res.data
    })


    selectCustomerCompanyListAll().then(res => {
      this.companyId.data = res.data
    })

  },
  methods: {
    getInfo() {
      getInfo(this.customerId).then(res => {
        this.formData = res.data
      })
    },
    submit(isNext) {
      const submit = this.customerId ? editUser : addUser;
      // 校验
      this.$refs.form.validate().then(() => {
        this.$loading.show()
        submit(this.formData).then(res => {
          this.$loading.hide()
          this.$toast(res.msg, {duration: 500})
          setTimeout(() => {
            isNext ? location.reload() : this.goBack()
          }, 500)
        })
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    firstContactConfirm(date) {
      this.formData.firstContact = moment(date).format('YYYY-MM-DD')
      this.firstContact.show = false
    },
  }

}
</script>
